/**
 * Support Widget 展示门控
 * @description 已全量放量，登录用户即可展示悬浮球
 */

/**
 * 是否展示智能客服悬浮球。
 * 未登录不展示；已登录全量展示（不再按 qtest 分流）。
 */
export function canShowSupportWidget(params: { isLogin: boolean }): boolean {
  return params.isLogin;
}
